// /apps/patient/src/components/navigation/FeatureGuard.tsx

import { Navigate } from 'react-router-dom';
import { useFeatures } from '../../contexts/FeatureContext';
import { PatientFeatures } from '@prism-ehr/shared';

interface FeatureGuardProps {
  feature: keyof PatientFeatures['enabled_features'];
  fallbackFeature?: keyof PatientFeatures['enabled_features'];
  children: React.ReactNode;
  fallback?: string;
}

export function FeatureGuard({
  feature,
  fallbackFeature,
  children,
  fallback = '/dashboard'
}: FeatureGuardProps) {
  const { features, isLoading, hasFeature } = useFeatures();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="w-16 h-16 border-4 border-primary border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!hasFeature(feature) && !(fallbackFeature && hasFeature(fallbackFeature))) {
    return <Navigate to={fallback} replace />;
  }

  return <>{children}</>;
}